/**
 * Protection Tiers API (Spec 201)
 *
 * Settings-managed protection tiers — each is the per-entity backup RPO/RTO objective (hours).
 * The owner edits rpo/rto here; readiness compares each entity's last backup against its tier's RPO.
 *
 * Author: Peter Dobler (Dobler Data Solutions) · Feature 201
 */
import apiClient from '../services/api';
import type { BackupEntityType } from './assignment';

export interface ProtectionTier {
  tierName: string;
  sortOrder: number;
  rpoHours: number | null;
  rtoHours: number | null;
  description: string | null;
  isActive: boolean;
}

type Wrapped<T> = { success: boolean; data: T };
const BASE = '/api/v1/backup';

export const tiersApi = {
  list: async (): Promise<ProtectionTier[]> =>
    (await apiClient.get<Wrapped<ProtectionTier[]>>(`${BASE}/protection-tiers`)).data,

  update: async (
    tierName: string,
    patch: { rpoHours?: number | null; rtoHours?: number | null; description?: string | null; isActive?: boolean }
  ): Promise<ProtectionTier[]> =>
    (await apiClient.put<Wrapped<ProtectionTier[]>>(`${BASE}/protection-tiers/${encodeURIComponent(tierName)}`, patch)).data,

  setEntityTier: async (entityType: BackupEntityType, entityId: string, tier: string): Promise<void> => {
    await apiClient.put(`${BASE}/entities/${entityType}/${entityId}/tier`, { tier });
  },
};
